export default {
  data() {

  },
  methods:{
    _openAdd(record) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Test.js